import cx from "classnames"
import React, { useState } from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"
import Button from "../Button"

const SplashCtaDropdown: React.FC = () => {
  const [isGetStartedOpen, toggleGetStarted] = useState(false)
  const [isRatesOpen, toggleRates] = useState(false)
  return (
    <div
      data-qa="cta-block"
      className={cx({
        [styles.splashCTA]: true,
        [styles.getStartedCTA]: true,
      })}
      id="get-started"
    >
      <div
        className={cx({
          [styles.button]: true,
          [styles.buttonJourney]: true,
        })}
        data-qa="journey-get-started"
      >
        <div
          className={cx({
            [styles.dropdown]: true,
            [styles.hover]: true,
            [styles.dropdownJourney]: true,
          })}
        >
          <div
            onClick={() => {
              toggleGetStarted(!isGetStartedOpen)
              toggleRates(false)
            }}
          >
            <Button type="primary" size="xxl" halo={true}>
              Get Started
            </Button>
          </div>
          <div
            className={cx({
              [styles.menu]: true,
              [styles.isOpen]: isGetStartedOpen,
            })}
          >
            <div className={styles.shadow}>
              <div className={styles.navbar}>
                <div className={styles.navbarLinks}>
                  <Link className={styles.navbarLink} to="/start-purchase">
                    <span className={styles.navbarLinkText}>Purchase</span>
                  </Link>
                  <Link className={styles.navbarLink} to="/start-refinance">
                    <span className={styles.navbarLinkText}>Refinance</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={cx({
          [styles.button]: true,
          [styles.buttonRates]: true,
        })}
        data-qa="splash-rates"
      >
        <div
          className={cx({
            [styles.dropdown]: true,
            [styles.hover]: true,
            [styles.dropdownRates]: true,
          })}
        >
          <div
            onClick={() => {
              toggleRates(!isRatesOpen)
              toggleGetStarted(false)
            }}
          >
            <Button type="secondary" size="xxl" halo={true}>
              View Rates
            </Button>
          </div>
          <div
            className={cx({
              [styles.menu]: true,
              [styles.isOpen]: isRatesOpen,
            })}
          >
            <div className={styles.shadow}>
              <div className={styles.navbar}>
                <div className={styles.navbarLinks}>
                  <div className={styles.navbarLink}>
                    <span className={styles.navbarLinkText}>Purchase</span>
                  </div>
                  <div className={styles.navbarLink}>
                    <span className={styles.navbarLinkText}>Refinance</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SplashCtaDropdown
